import { render, staticRenderFns } from "./WorkOrder.vue?vue&type=template&id=72a65dea&scoped=true&"
import script from "./WorkOrder.vue?vue&type=script&lang=js&"
export * from "./WorkOrder.vue?vue&type=script&lang=js&"
import style0 from "./WorkOrder.vue?vue&type=style&index=0&id=72a65dea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a65dea",
  null
  
)

export default component.exports